import {getBulkActionSlice} from 'src/components/bulk-tool';

import type {
    BulkActionIdSelector,
    BulkActionShownSelector,
    BulkActionTaskSelector,
} from 'src/components/bulk-tool';

export const unassignUserEntitlementsSlice = getBulkActionSlice(
    'unassignUserEntitlementsResult',
);

export const selectUnassignUserEntitlementsShown: BulkActionShownSelector = state =>
    state.bulkUpdateResult.unassignUserEntitlementsResult.shown;

export const selectUnassignUserEntitlementsBulkUuid: BulkActionIdSelector = state =>
    state.bulkUpdateResult.unassignUserEntitlementsResult.uuid;

export const selectUnassignUserEntitlementsTask: BulkActionTaskSelector = state =>
    state.bulkUpdateResult.unassignUserEntitlementsResult.backgroundTask;

export const {
    setUuid,
    setBackgroundTask,
    setShown,
    clearResult,
} = unassignUserEntitlementsSlice.actions;
